import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Building2 } from "lucide-react";
import { fmtDate } from "@/lib/format";

export default function AdminOrganizations() {
  const { user } = useAuth();
  const [overview, setOverview] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setOverview(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-organizations" className="space-y-4">
      <div>
        <h1 className="font-heading text-2xl font-semibold tracking-tight">Organizations</h1>
        <p className="text-sm text-muted-foreground">Your SaaS tenant scope. Each organization's buyers, suppliers, POs and settings are fully isolated.</p>
      </div>
      <div className="rounded-lg border bg-card">
        <div className="flex items-center gap-4 border-b p-5">
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-slate-900 text-white"><Building2 className="h-6 w-6" /></div>
          <div>
            <h2 className="font-heading text-lg font-semibold" data-testid="org-name">{user?.org_name}</h2>
            <p className="text-sm text-muted-foreground">Primary organization · multi-tenant isolated</p>
          </div>
          <span className="ml-auto rounded-full border border-[#BBF7D0] bg-[#DCFCE7] px-2.5 py-0.5 text-xs font-semibold text-[#166534]">ACTIVE</span>
        </div>
        {overview && (
          <div className="grid grid-cols-2 gap-px bg-slate-100 md:grid-cols-5">
            {Object.entries(overview.counts).map(([k, v]) => (
              <div key={k} className="bg-white p-4">
                <p className="text-xs uppercase tracking-wide text-muted-foreground">{k.replace("_", " ")}</p>
                <p className="mt-1 font-heading text-2xl font-semibold">{v}</p>
              </div>
            ))}
          </div>
        )}
        <div className="border-t px-5 py-3 text-sm text-muted-foreground">
          WhatsApp integration: <span className="font-semibold capitalize">{overview?.whatsapp_status?.replace("_", " ") || "not configured"}</span> · Email mode: <span className="font-semibold capitalize">{overview?.email_mode || "mock"}</span>
        </div>
      </div>
    </div>
  );
}
